// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';

export type HistoriesCsvExportSliceState = {
  isExporting: boolean;
};

const initialState: HistoriesCsvExportSliceState = {
  isExporting: false,
};

export const historiesCsvExportSlice = createSlice({
  name: 'historiesCsvExport',
  initialState,
  reducers: {
    setIsExporting: (state, action: PayloadAction<boolean>) => {
      state.isExporting = action.payload;
    },
    resetHistoriesExport: () => {
      return initialState;
    },
  },
});

export const { setIsExporting, resetHistoriesExport } =
  historiesCsvExportSlice.actions;

export const selectIsExporting = (state: RootState) =>
  state.historiesCsvExport.isExporting;

export default historiesCsvExportSlice.reducer;
